import { Component } from '@ecs/Component';

export class Health implements Component {
  readonly type = 'Health';

  constructor(
    public current: number,
    public max: number
  ) {}
}